import { compose } from '../../helpers/compose'
import WithData from './withData'
import WithLayout from './withLayout'
import WithPermissions from './withPermissions'
import withWidget from './withWidget'

export default compose(WithData, WithLayout, withWidget, WithPermissions)
